// extracted by mini-css-extract-plugin
module.exports = {"root":"SubscriptionAdviceBanner_root__1ib49","text":"SubscriptionAdviceBanner_text__1uV09","button":"SubscriptionAdviceBanner_button__1_-s8"};